import utils from '@/_modules/utils';

class _gnav {
  constructor() {}

  once(isTop) {
    this.anchorID = '';
    if (location.hash.indexOf('#anchorto__') > -1) {
      this.anchorID = location.hash.replace('#anchorto__', '');
    }
    this.isTop = isTop;
    this.isOpen = false;
    this.adjust = 0;
    this.pastScrollY = 0;
    this.pastWidth = 0;

    // ナビ全体
    this.el = document.getElementById('c-gnav');
    
    // PC　ヘッダーナビ
    this.header = document.getElementById('c-header');
    if (this.isTop) {
      this.header.querySelectorAll('.is-anchor').forEach((a, i) => {
        a.addEventListener('click', this.settingAnchor.bind(this, a.hash.replace('#anchorto__', '')));
      });
    }

    // スマホ モーダルナビ
    this.modal = document.getElementById('c-gnav__modal');
    this.modal.querySelectorAll('.is-anchor').forEach((a, i) => {
      a.addEventListener('click', this.settingAnchor.bind(this, a.hash.replace('#anchorto__', '')));
    });
    this.btnToggle = document.getElementById('c-trigger');
    this.btnToggle.addEventListener('click', this.toggleModal.bind(this));
  }

  start() {
    // URLアンカー
    if (this.anchorID) {
      requestAnimationFrame(this.gotoAnchor.bind(this, this.anchorID));
    }
  }

  settingAnchor(id, e) {
    e.preventDefault();
    this.closeNav();
    this.gotoAnchor(id);
  }

  gotoAnchor(id) {
    const target = document.querySelector(`#${id}`);
    if (target) {
      const offset = utils.getOffsetTop(target);
      gsap.to(window, {
        duration: 0.7,
        delay: 0.3,
        scrollTo: {
          y: offset.top - this.adjust,
          autoKill: false,
        },
        ease: Power3.easeOut
      });
    }
  }

  toggleModal() {
    if (this.isOpen) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }

  openNav() {
    if (this.isOpen) return;
    this.isOpen = true;
    gTOCO.rootHTML.classList.add('is-gnav--modal-open');

    gsap.fromTo(this.modal, {
      display: 'flex',
      opacity: 0,
    }, {
      duration: 0.7,
      opacity: 1,
      ease: Power3.easeOut,
      onComplete: this.openNavComp.bind(this),
    });
  }

  openNavComp() {
    this.pastScrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;

    const body = document.body;
    body.style.overflow = 'hidden';
    //body.style.overflowX = 'hidden';
    //body.style.overflowY = 'scroll';
    //body.style.position = 'fixed';
    //body.style.height = 'auto';

    //gEvent.emit('OPEN_GNAV');
  }

  closeNav() {
    if (!this.isOpen) return;
    this.isOpen = false;
    gTOCO.rootHTML.classList.remove('is-gnav--modal-open');

    gsap.to(this.modal, {
      duration: 0.7,
      display: 'none',
      opacity: 0,
      ease: Power3.easeOut,
      onComplete: this.closeNavComp.bind(this),
    });

    const body = document.body;
    body.style.overflowX = '';
    body.style.overflowY = '';
    body.style.position = '';
    body.style.height = '';

    window.scrollTo(0, this.pastScrollY);

    //gEvent.emit('CLOSE_GNAV');
  }

  closeNavComp() {
    //this.el.classList.remove('c-gnav--modal-open');
  }

  resize() {
    this.closeNav();
    const winW = utils.getBodyWidth();
    if (utils.getMatchMedia()) {
      this.adjust = (100 / 750) * winW;
      ///////////////
      // SP
      ///////////////
      if (this.ispc && winW !== this.pastWidth) {
        //this.resetPc();
      }
    } else {
      this.adjust = 140;
      ///////////////
      // PC
      ///////////////
      if (!this.ispc) {
        //this.initPc();
      }
    }

    this.pastWidth = winW;
  }
}

const gnav = new _gnav();

export default gnav;